import { render, staticRenderFns } from "./MaterialVariantLocationListing.vue?vue&type=template&id=196a0a98&scoped=true"
import script from "./MaterialVariantLocationListing.vue?vue&type=script&lang=js"
export * from "./MaterialVariantLocationListing.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariantLocationListing.vue?vue&type=style&index=0&id=196a0a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a0a98",
  null
  
)

export default component.exports